export class DialogModelGenerateDn {
    constructor(
      public invoice: any,
      public message: string,
      public key: any,
      public dialogType: string
    ) {}
  }